import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import StockModel from '../models/StockModel';
import StockStatiticModel from '../models/StockStatiticModel';
import { string } from 'prop-types';
import StockQueryModel from '../models/StockQueryModel';
import Utility from '../../../app/utility';

interface StockSearchState {
    stockStatitics: StockStatiticModel[],
    stockDetails: StockModel[],
    query: StockQueryModel,
    triggerRefreshStatitic: number,
    triggerSearchStockDetail: number,
    showStockDetailModal: boolean,
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
}

const initialState: StockSearchState = {
    stockStatitics: [],
    stockDetails: [],
    query: {
        item: "",
        dateFrom: "",
        dateTo: ""
    } as StockQueryModel,
    triggerRefreshStatitic: 0,
    triggerSearchStockDetail: 0,
    showStockDetailModal: false,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
}

export const StockSearchSlice = createSlice({
    name: "StockSearch",
    initialState,
    reducers: {
        setStockStatitics: (state, action: PayloadAction<StockStatiticModel[]>) => {
            state.stockStatitics = action.payload;
        },
        setStockDetails: (state, action: PayloadAction<StockModel[]>) => {
            state.stockDetails = action.payload;
        },
        setTriggerRefreshStockDetail: (state, action: PayloadAction<number>) => {
            state.triggerSearchStockDetail = action.payload;
        },
        setTriggerRefreshStatitic: (state, action: PayloadAction<number>) => {
            state.triggerRefreshStatitic = action.payload;
        },
        setDatatableSelectedStockIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setQueryItemInit: (state, action: PayloadAction<string>) => {
            state.query.item = action.payload;
            state.query.dateFrom = Utility.DateFormat.format(new Date(new Date().getFullYear(), 0, 1))
            state.query.dateTo = Utility.DateFormat.format(Utility.addDaysToDate(new Date(), 1));
        },
        setQueryItem: (state, action: PayloadAction<string>) => {
            state.query.item = action.payload;
        },
        setQueryDateFrom: (state, action: PayloadAction<string>) => {
            state.query.dateFrom = action.payload;
        },
        setQueryDateTo: (state, action: PayloadAction<string>) => {
            state.query.dateTo = action.payload;
        },
        setShowStockDetailModal: (state, action: PayloadAction<boolean>) => {
            state.showStockDetailModal = action.payload;
        },
    }
});

export const StockSearchSelector = createSelector(
    (state: RootState) => state.stockSearch,
    (data) => data
);

export const {
    setStockStatitics,
    setStockDetails,
    setTriggerRefreshStockDetail,
    setTriggerRefreshStatitic,
    setDatatableSelectedStockIndex,
    setSearchResultTotalRecord,
    setQueryItemInit,
    setQueryItem,
    setQueryDateFrom,
    setQueryDateTo,
    setShowStockDetailModal
} = StockSearchSlice.actions;

export default StockSearchSlice.reducer;